module.exports = __webpack_public_path__ + "static/media/coins.bf1f1d62.png";